import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ARStoryOption } from 'src/app/_models/ARStoryOption';
import { Config } from 'src/app/_models/config';

@Component({
  selector: 'app-interactive-ar',
  templateUrl: './interactive-ar.component.html',
  styleUrls: ['./interactive-ar.component.scss']
})
export class InteractiveARComponent {
  @Input() feature: any;
  @Input() models: any[];
  @Input() voices: any[];
  @Input() animations: any[];
  @Input() clientId: string;
  @Input() projectId: string;
  @Input() config: Config;
  @Output() featureChange = new EventEmitter<any>();

  selectedElement: ARStoryOption;

ngOnInit() {
  // console.log('[InteractiveARComponent] Initial feature.characterExpanded:', this.feature?.characterExpanded); // Removed log
}

toggleCharacterExpanded() {
  this.feature.characterExpanded = !this.feature.characterExpanded;
  // console.log('[InteractiveARComponent] Toggled feature.characterExpanded to:', this.feature.characterExpanded); // Removed log
    this.featureChange.emit(this.feature);
  }
  
  getModelImagePath(modelId: string): string {
    return 'assets/models/' + modelId + '.png';
  }
  
  toggleSceneExpanded() {
    this.feature.sceneExpanded = !this.feature.sceneExpanded;
    this.featureChange.emit(this.feature);
  }

  onModelChange() {
    this.feature = { ...this.feature };
    this.featureChange.emit(this.feature);
  }

  onVoiceChange() {
    this.featureChange.emit(this.feature);
  }

  playInteractiveAudio() {
    const path = this.feature.interactiveVoice.file;
    const audio = new Audio(path);
    audio.play();
  }

  isModelGlb(feature: any): boolean {
    if (feature.value.modelFile !== undefined) {
      return true;
    } else if (feature.value.modelUrl !== undefined) {
      let url = ((feature.value.modelUrl) as string).toLowerCase();
      return url.endsWith(".glb") || url.endsWith(".gltf");
    }
    return false;
  }

  updateSelectedElement(element: ARStoryOption) {
    this.selectedElement = element;
    this.featureChange.emit(this.feature);
  }

  onElementChange() {
    this.featureChange.emit(this.feature);
  }
}